import './i18n'
import Element from './element-ui'
import ErrorHandler from './error-handler'
import FileManager from './file-manager'
import Icons from './icons'
import Inflected from './inflected'
import Lodash from './lodash'
import Moment from './moment'
import Mousetrap from './mousetrap'
import Navigation from './navigation'
import Papaparse from './papaparse'
import SDK from './sdk'
import { install as Session } from './session'
import { install as Device } from './device'
import { install as Sheep } from './sheep'
import User from './user'
import VTooltip from 'v-tooltip'
import VueClipboard from 'vue-clipboard2'
import CGrid from 'vue-cheetah-grid'
import VueContentPlaceholders from 'vue-content-placeholders'
import Pusher from './pusher'
import Alfred from './alfred'

export default {
  install (Vue) {
    Vue.use(Element)
    Vue.use(ErrorHandler)
    Vue.use(FileManager)
    Vue.use(Icons)
    Vue.use(Inflected)
    Vue.use(Lodash)
    Vue.use(Moment)
    Vue.use(Mousetrap)
    Vue.use(Alfred)
    Vue.use(Navigation)
    Vue.use(Papaparse)
    Vue.use(SDK)
    Vue.use(Session)
    Vue.use(Device)
    Vue.use(Sheep)
    Vue.use(User)
    Vue.use(VTooltip)
    Vue.use(VueClipboard)
    Vue.use(CGrid)
    Vue.use(VueContentPlaceholders)
    Vue.use(Pusher)
  }
}
